import label from "@/lang/StaticLabels.js";

// Parak Navbar  - Ø³Ù�Ø§Ø±Ø´Ø§Øª Ø¯Ø§Ù†Ù‡ Ø¨Ø§Ø± -----------------------------------------------
let navItems = [
  {
    title: label.modules.parak,
    icon: "mdi-map-marker-radius",
    to: false,
  },
  {
    to: "PPARAKDashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.menu.baseInformation,
    icon: "pi pi-database",
    active: false,
    subItems: [
      {
        to: "PPARAKCommodityCategory",
        label: label.menu.category,
        metaLabel: label.page.category,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PPARAKCommodityIntroductionList",
        label: label.menu.commodityIntroduction,
        metaLabel: label.page.commodityIntroduction,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PPARAKDealType",
        label: label.menu.dealType,
        metaLabel: label.page.dealType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PPARAKSettingTransactions",
        label: label.menu.settingTransactions,
        metaLabel: label.page.settingTransactions,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.operation,
    icon: "mdi-wrench-outline",
    active: false,
    subItems: [
      {
        to: "PPARAKCottageList",
        label: label.menu.cottage,
        metaLabel: label.page.cottage,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: "PPARAKPurchaseList",
        label: label.menu.purchase,
        metaLabel: label.page.purchase,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: "PPARAKOrderList",
        label: label.menu.parakOrder,
        metaLabel: label.page.parakOrder,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: "PPARAKLadingList",
        label: label.menu.lading,
        metaLabel: label.page.lading,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.reports,
    icon: "mdi-chart-bar-stacked",
    active: false,
    subItems: [
      {
        to: "PPARAKCottageReport",
        label: label.menu.cottageReport,
        metaLabel: label.page.cottageReport,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: "PPARAKPurchaseReport",
        label: label.menu.purchaseReport,
        metaLabel: label.page.purchaseReport,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: "PPARAKOrderReport",
        label: label.menu.orderReport,
        metaLabel: label.page.orderReport,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: "PPARAKComprehensiveOrderReport",
        label: label.menu.comprehensiveOrder,
        metaLabel: label.page.comprehensiveOrder,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
    ],
  },
];

export default navItems;
